import QuestionContent from './question-content';
import Segment from '../../shared/segment';
import QuestionTitle from './question-title';
import { QuestionOverviewType } from '../../../api/student-question';

export type QuestionPropsType = {
  questionNumber: number;
  questionCount: number;
  question: QuestionOverviewType;
  studentQuestionId: number;
  selectedOptionId: number | null;
};

function Question({
  questionNumber,
  questionCount,
  question,
  studentQuestionId,
  selectedOptionId
}: QuestionPropsType) {
  return (
    <div>
      <Segment noMargin color={selectedOptionId ? 'blue' : 'gray'}>
        <QuestionTitle questionNumber={questionNumber} questionCount={questionCount} />
        <div className='mx-3'>
          <QuestionContent
            question={question}
            studentQuestionId={studentQuestionId}
            selectedOptionId={selectedOptionId}
          />
        </div>
      </Segment>
    </div>
  );
}

export default Question;
